// Club configuration with locations
export const CLUB_LOCATIONS = {
    "Perfect Harmony Club (Mridanga)": "FPH",
    "Perfect Harmony Club (Kartal)": "Gadadhar Hall", 
    "Cross Fire Club (Public Speaking, Debate etc)": "Gauranga Hall",
    "Rhythm Club (Djembe)": "Folk Vrindavan Lawn",
    "Resonance Club (Singing & Mantra Chanting)": "Acharya Peetham"
};

// Function to get location by club name
export const getClubLocation = (clubName) => {
    return CLUB_LOCATIONS[clubName] || "Location not found";
};